import { c as _c } from "react/compiler-runtime";
import { Chips, DataStatus, Separator } from 'platform/components';
import { HStack, VStack } from 'platform/foundation-tw';
import { intersection } from 'ramda';
import { isArray, isEmptyArray } from 'ramda-adjunct';
import { suffixTestId, useOnMount, type Nullish } from 'shared/web';
import { quickFiltersConst } from '../../constants/quickFilters';
import { useChoiceFilter } from '../../hooks/useChoiceFilter';
import { useFilterOnChipsChange } from '../../hooks/useFilterOnChipsChange';
import { useLazyChoiceFilterOptions } from '../../hooks/useLazyChoiceFilterOptions';
import type { EagFilterProps } from '../../types/EagFilterProps';
export type ChipsFilterProps = EagFilterProps & {
  columnKey: string;
  quickFilters?: Array<{
    value: string;
    label: string;
  }>;
};
const FILTER_VALUE_KEY = 'value';
export function ChipsFilter(props) {
  const $ = _c(37);
  const rawModel = props.value[FILTER_VALUE_KEY] as string[] | string | Nullish;
  let t0;
  if ($[0] !== props) {
    t0 = newValue => {
      props.onChange({
        [FILTER_VALUE_KEY]: newValue
      });
    };
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== rawModel || $[3] !== t0) {
    t1 = {
      model: rawModel,
      onChange: t0
    };
    $[2] = rawModel;
    $[3] = t0;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const [values, setValues] = useChoiceFilter(t1);
  let t2;
  if ($[5] !== props.columnKey) {
    t2 = {
      columnKey: props.columnKey
    };
    $[5] = props.columnKey;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const {
    loadOptions,
    isLoading,
    options,
    errorMessage
  } = useLazyChoiceFilterOptions(t2);
  let t3;
  if ($[7] !== setValues) {
    t3 = {
      setFilterValue: setValues,
      defaultValue: null
    };
    $[7] = setValues;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const {
    onChipsChange
  } = useFilterOnChipsChange(t3);
  let t4;
  if ($[9] !== values) {
    t4 = isArray(values) ? values : [values];
    $[9] = values;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t4) {
    t5 = intersection(t4, quickFiltersConst);
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  const isQuickFilterValue = t5;
  const isControlDisabled = props.isDisabled;
  let t6;
  if ($[13] !== loadOptions) {
    t6 = () => {
      loadOptions();
    };
    $[13] = loadOptions;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  useOnMount(t6);
  let t7;
  if ($[15] !== isQuickFilterValue || $[16] !== onChipsChange || $[17] !== props) {
    t7 = props.quickFilters && props.quickFilters.length > 0 && <><HStack><Chips isDisabled={props.isDisabled} value={isQuickFilterValue} options={props.quickFilters} onChange={onChipsChange} isMultiple={false} data-testid={suffixTestId("chips-filter-quickFilters", props)} isDeselectable={true} /></HStack><Separator /></>;
    $[15] = isQuickFilterValue;
    $[16] = onChipsChange;
    $[17] = props;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== isQuickFilterValue || $[20] !== values) {
    t8 = isEmptyArray(isQuickFilterValue) && isArray(values) ? values : null;
    $[19] = isQuickFilterValue;
    $[20] = values;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  let t9;
  if ($[22] !== props) {
    t9 = suffixTestId("chips-filter", props);
    $[22] = props;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  let t10;
  if ($[24] !== errorMessage || $[25] !== isControlDisabled || $[26] !== options || $[27] !== setValues || $[28] !== t8 || $[29] !== t9) {
    t10 = <Chips isDisabled={isControlDisabled} options={options} value={t8} onChange={setValues} isMultiple={true} isDeselectable={true} errorMessage={errorMessage} data-testid={t9} />;
    $[24] = errorMessage;
    $[25] = isControlDisabled;
    $[26] = options;
    $[27] = setValues;
    $[28] = t8;
    $[29] = t9;
    $[30] = t10;
  } else {
    t10 = $[30];
  }
  let t11;
  if ($[31] !== isLoading || $[32] !== t10) {
    t11 = <DataStatus isLoading={isLoading}>{t10}</DataStatus>;
    $[31] = isLoading;
    $[32] = t10;
    $[33] = t11;
  } else {
    t11 = $[33];
  }
  let t12;
  if ($[34] !== t11 || $[35] !== t7) {
    t12 = <VStack>{t7}{t11}</VStack>;
    $[34] = t11;
    $[35] = t7;
    $[36] = t12;
  } else {
    t12 = $[36];
  }
  return t12;
}